import paymentSummaryProfile from './paymentSummaryProfileSchema';
import loginAttempt from '../profile/schemas/loginAttemptSchema';
import userLoginSchema from '../profile/schemas/userLoginSchema';
import userSignUpSchema from './schemas/userSignUpSchema';
import loginFailSchema from '../profile/schemas/loginFailSchema';
import logOutSchema from '../profile/schemas/logOutSchema';
import stepSchema from '../profile/schemas/stepSchema';
import loginCobrandedSchema from './schemas/loginCobrandedSchema';
import loginTarjetaSchema from '../profile/schemas/loginTarjetaSchema';
import useSavedPaymentMethodsSchema from '../profile/schemas/useSavedPaymentMethodsSchema';
import apiErrorSchema from '../profile/schemas/apiErrorSchema';
import updateConsentCpSchema from '../profile/schemas/updateConsentCpSchema';
import userProfileRegistrationOtpSchema from './schemas/userProfileRegistrationOtpSchema';
import receiptDownloadSchema from './schemas/receiptDownloadSchema';
import recoverPinPasswordSchema from './schemas/recoverPinPasswordSchema';import upgradeVoucherRedeemSchema from './schemas/upgradeVoucherRedeemSchema';


export default {
  apiErrorSchema,
  loginAttempt,
  loginCobrandedSchema,
  loginFailSchema,
  loginTarjetaSchema,
  logOutSchema,
  paymentSummaryProfile,
  receiptDownloadSchema,
  recoverPinPasswordSchema,
  stepSchema,
  upgradeVoucherRedeemSchema,
  userLoginSchema,
  userSignUpSchema,
  updateConsentCpSchema,
  userProfileRegistrationOtpSchema,
  useSavedPaymentMethodsSchema,
};
